import { createTelemetryAPI } from '~/utils/telemetry'

export const clusterFilesTelemetry = createTelemetryAPI(({ track }) => ({
  selectTimeRange(payload: { time_range_type: string }) {
    return track('Cluster Files: Select Time Range', payload)
  },
  clickQuery() {
    return track('Cluster Files: Click Query')
  },
  clickDownload() {
    return track('Cluster Files: Click Download')
  }
}))
